import { filterParams } from '../helpers/filterParams';
import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';

interface ITrackScreenOptions {
	screenName: string;
}

export function trackScreen(options: ITrackScreenOptions) {
	const { screenName } = options;

	const customParams = {
		app_screen_name: screenName,
	};

	const defaultParams = {
		page_title: screenName,
		page_path: window.location.pathname,
	};

	const params = filterParams({ ...defaultParams, ...customParams });

	trackWithGoogleAnalytics('event', 'page_view', params);
}
